module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_yq_zhny@2x.97bf9dca.png";